
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/birthday-bot/free-birthday-bot-slack",
      function () {
        return require("private-next-pages/birthday-bot/free-birthday-bot-slack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/birthday-bot/free-birthday-bot-slack"])
      });
    }
  